import React from 'react';
import { TextLink } from '@guildeducationinc/recess';
import { useClearRefinements } from 'react-instantsearch-hooks-web';

interface Props {
	ctaCopy?: string;
}

export const ResetFiltersAnchor: React.FC<Props> = props => {
	const { ctaCopy = 'clearing your filters' } = props;
	const { refine } = useClearRefinements();

	return (
		<TextLink data-testid='clear-facets-cta' onClick={refine} tabIndex={0}>
			{ctaCopy}
		</TextLink>
	);
};
